module.exports = __webpack_public_path__ + "img/d4ea892.svg";